const cl_warn = {
	0: 'No alarm',
	10: 'Trend acceleration',
	20: 'Trend deccleration',
	11: 'Noise increase',
	12: 'Abrupt jump in trend',
	22: 'Abrupt jump in trend',
	500: 'Trend inversion',
};

const chng_type = {
	'Densif./Rebuild.': 'Rebuilding (in the last decade)',
	Sprawl: 'Expansion (in the last decade)',
	13300: 'Construction area (current)',
};

export default {
	cl_warn,
	chng_type,
};
